<section class="request" *ngIf="requestData">
  <h5 class="request--title">{{ 'requestInfo' | i18next }}</h5>
  <div class="request--infoContainer">
    <div class="rowInfo">
      <p class="label">
        {{ 'requestType' | i18next }}
      </p>
      <p class="text">
        {{ this.translate.translateRequestTypes(requestData.requestType) }}
      </p>
    </div>
    <div
      class="rowInfo"
      *ngIf="requestData.requestType !== requestTypeEnum.didactic"
    >
      <p class="label">
        {{ 'requestSubtype' | i18next }}
      </p>
      <p
        class="text"
        *ngIf="
          requestData.requestType !== requestTypeEnum.loan &&
          requestData.requestType !== requestTypeEnum.proyect
        "
      >
        {{ this.translate.translateRequestSubtypes(requestData.orderSubType) }}
      </p>
      <p class="text" *ngIf="requestData.requestType === requestTypeEnum.loan">
        {{
          this.translate.translateRequestSubtypes(
            requestData.loanDataDTO.loanType
          )
        }}
      </p>
      <p
        class="text"
        *ngIf="requestData.requestType === requestTypeEnum.proyect"
      >
        {{ this.translate.translateProjects(requestData.projectSubType) }}
      </p>
    </div>
    <div
      class="rowInfo"
      *ngIf="requestData.requestType === requestTypeEnum.didactic"
    >
      <p class="label">
        {{ 'didacticUse' | i18next }}
      </p>
      <p class="text">
        {{
          this.translate.translateRequestSubtypes(
            requestData.educationalDataDTO.use
          )
        }}
      </p>
    </div>
    <div class="rowInfo">
      <p class="label">
        {{ 'observations' | i18next }}
      </p>
      <p class="text">
        {{ requestData.observations ? requestData.observations : '-' }}
      </p>
    </div>
    <div
      class="rowInfo"
      *ngIf="
        requestData.requestType === requestTypeEnum.dotArr ||
        requestData.requestType === requestTypeEnum.campaigns
      "
    >
      <p class="label">{{ 'requestRetributionType' | i18next }}</p>
      <p class="text">
        {{ this.translate.translateRetribution(requestData.retribution) }}
      </p>
    </div>
    <div class="rowInfo" *ngIf="requestData?.generalServicesDetailData">
      <p class="label">
        {{ 'requestSubtypeSust' | i18next }}
      </p>
      <p
        class="text"
        *ngIf="requestData?.generalServicesDetailData?.stockVehicleDTO"
      >
        {{ 'flotaSeat' | i18next }}
      </p>
      <p
        class="text"
        *ngIf="requestData?.generalServicesDetailData?.newVehicleDTO"
      >
        {{ 'backofficeNavNewCampaign' | i18next }}
      </p>
    </div>
  </div>
</section>
